import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Subscription from './Subscription.react';
import AddressInput from '../../AddressInput/AddressInput.react';
import '../subscription.scss';

/**
 * A list of direct addresses for a given provider at a sending facility
 */
class SubscriptionAddresses extends Component {
	constructor(props) {
		super(props);
		this.onClickAddAddress = this.onClickAddAddress.bind(this);
		this.onClickCreate = this.onClickCreate.bind(this);
		this.state = {
			subscriptions: props.subscription.subscriptions
		};
	}

	onClickAddAddress(address, subscription, successCallback, errorCallback) {
		this.props.onClickAddAddress({
			npi: subscription.npi,
			sendingFacilityId: subscription.sendingFacilityId,
			demographics: subscription.nppesDemographic,
			sendingFacilityDisplayName: subscription.sendingFacilityDisplayName,
			manualAddress: address
		}, (response) => {
			if (response.entities && response.entities.subscriptions && response.result) {
				this.setState((prevState) => ({
					subscriptions:
						prevState.subscriptions.concat(response.result.map((r) => {
							const s = response.entities.subscriptions[r];
							const status = {
								OPT_IN: '1',
								OPT_OUT: '2',
								OPT_OUT_ALL: '16',
								INTERNAL_DOMAIN: '32'
							};
							return {
								npi: s.npi,
								directAddress: s.directAddress,
								sendingFacilitySubscriptionStatus:
									status[s.directAddressSubscriptionStatus]
									|| s.directAddressSubscriptionStatus,
								id: s.id,
								providerSubscriptionAdtTypePreference: s.adtSubscriptionPreferenceMask,
								subscriptionSourceDisplay: 'MANUAL'
							};
						}))
				}));
			}

			if (successCallback) {
				successCallback();
			}
		}, errorCallback);
	}

	onClickCreate(address, documentId, subscription) {
		this.props.onClickAddAddress({
			npi: subscription.npi,
			sendingFacilityId: subscription.sendingFacilityId,
			providerSubscriptionStatusDocumentId: documentId,
			hpdAddresses: [address]
		}, (response) => {
			if (response.entities && response.entities.subscriptions && response.result) {
				this.setState((prevState) => ({
					subscriptions:
						prevState.subscriptions.concat(response.result.map((r) => {
							const s = response.entities.subscriptions[r];
							const status = {
								OPT_IN: '1',
								OPT_OUT: '2',
								OPT_OUT_ALL: '16',
								INTERNAL_DOMAIN: '32'
							};
							return {
								npi: s.npi,
								directAddress: s.directAddress,
								sendingFacilitySubscriptionStatus:
									status[s.directAddressSubscriptionStatus]
									|| s.directAddressSubscriptionStatus,
								id: s.id,
								providerSubscriptionAdtTypePreference: s.adtSubscriptionPreferenceMask,
								subscriptionSourceDisplay: 'MANUAL'
							};
						}))
				}));
			}
		});
	}

	render() {
		const addresses = this.state.subscriptions.map((s) => (
			<Subscription
				{...s}
				communityId={this.props.communityId}
				communityName={this.props.communityName}
				history={this.props.history}
				onClickOptIn={() => this.props.onClickOptIn(s.id)}
				onClickOptOut={() => this.props.onClickOptOut(s.id)}
				onClickInactivate={(subscriptionId, communityId, isActive, deleteMultiple) => this.props.onClickInactivate(subscriptionId, communityId, isActive, deleteMultiple)}
				key={`${s.id}-${s.directAddress}-subscription`}
				providerSubscriptionAdtTypePreference={s.adtSubscriptionPreferenceMask || this.props.subscription.systemDefaultPreferenceBitMask}
				onClickSendResubscribeEmail={() => this.props.onClickSendResubscribeEmail(s.id)}
				systemDefaultSubscriptionAdtTypePreference={this.props.subscription.systemDefaultPreferenceBitMask}	
			/>
		));

		return (
			<div>
				{addresses}
				{this.props.query && this.props.query.status !== '64'
					&& <AddressInput
							id={`${this.props.subscription.providerAtSendingFacilityId}-address-input`}
							addAddress={(address, successCallback, errorCallback) => this.onClickAddAddress(
								address, this.props.subscription, successCallback, errorCallback
							)}
						/>
				}
				
			</div>
		);
	}
}
SubscriptionAddresses.propTypes = {
	onClickOptOut: PropTypes.func.isRequired,
	onClickOptIn: PropTypes.func.isRequired,
	onClickAddAddress: PropTypes.func.isRequired,
	onClickSendResubscribeEmail: PropTypes.func.isRequired,
	onClickInactivate: PropTypes.func.isRequired,
	subscription: PropTypes.shape({
		npi: PropTypes.string.isRequired,
		subscriptions: PropTypes.arrayOf(PropTypes.object),
		sendingFacilityId: PropTypes.string.isRequired,
		nppesDemographic: PropTypes.object.isRequired,
		sendingFacilityDisplayName: PropTypes.string,
		providerAtSendingFacilityId: PropTypes.string.isRequired,
		adtSubscriptionPreferenceMask: PropTypes.number
	}).isRequired
};

export { SubscriptionAddresses as default };
